import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  :root {
    --primary-color: #4E433C;
    --secondary-color: #92897B;
    --tertiary-color: #DED8D4;
    --quaternary-color: #1F1E1D;
    --disabled-color: #D8D8D8;
    --point-color: #920000;
    --padding: 10px;
    --margin: 20px;
    --gnb-height:85px;
    --border-radius:8px;
    --border-color:#ebebeb;
    --background:#F3F4F1;
    --max-width:1200px;
  }
`;

export default GlobalStyle;
